import React, { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import OrderStatus from "../../pages/orderStatus/OrderStatus";
import Dashboard from "../../pages/dashboard/Dashboard";
import Inquiries from "../../pages/inquiries/Inquiries";
import DownloadPolicies from "../../pages/DownloadPolicies/DownloadPolicies";
import PolicyPickup from "../../pages/DownloadPolicies/PolicyPickup";
import ReadyforPickupDocuments from "../../pages/orderStatus/ReadyforPickupDocuments";
import SecureLogin from "../../pages/secureLogin/SecureLogin";

//loading OrderStatus lazy  may cause CSS failure
//const OrderStatus = lazy(() => import('../../pages/orderStatus/OrderStatus'));
const NotificationHistory = lazy(() =>
  import("../../pages/account/NotificationHistory")
);
const ManageBillingHistory = lazy(() =>
  import("../../pages/account/ManageBillingHistory")
);
const QuoteSummary = lazy(() => import("../forms/quote/QuoteSummary"));
const ManageBillingPaymentInformationHistory = lazy(() =>
  import("../../pages/account/ManageBillingPaymentInformationHistory")
);
const IDverificationPage = lazy(() =>
  import("../../pages/IDVerificationPage/IDVerificationPage")
);
const Login = lazy(() => import("../../pages/login/Login"));
const ForgotPassword = lazy(() =>
  import("../../pages/forgotPassword/ForgotPassword")
);
const QuickRegister = lazy(() =>
  import("../../pages/quickRegister/QuickRegister")
);
const Registration = lazy(() =>
  import("../../pages/registration/Registration")
);
const ChangePassword = lazy(() =>
  import("../../pages/changePassword/ChangePassword")
);
const ResetPassword = lazy(() =>
  import("../../pages/resetPassword/ResetPassword")
);

const Orders = lazy(() => import("../../pages/orders/Orders"));
const AuthGuard = lazy(() => import("../../common/AuthGuard"));
const OrderSummaryMain = lazy(() =>
  import("../../pages/ordersSummary/OrderSummaryMain")
);
const ViewOrders = lazy(() => import("../../pages/viewOrders/ViewOrders"));
const AdjudicatedOrder = lazy(() =>
  import("../../pages/adjudicatedOrders/AdjudicatedOrder")
);
const Profile = lazy(() => import("../../pages/account/AccountSummary"));
const ProfileHistory = lazy(() => import("../../pages/account/ProfileHistory"));

// all the pages are lazy loaded which ensures that a page is only imported when it's relevant route is visited.
// This ensures that our application load time is improved since we won't be importing all the pages at once.

const Quote = lazy(() => import("../../pages/quote/Quote"));
const QuoteHistory = lazy(() => import("../../pages/quote/QuoteHistory"));
const OktaLoginCallback = lazy(() =>
  import("../../components/okta/OktaLoginCallback")
);

function Router() {
  return (
    <>
      <Suspense fallback={<div>..loading</div>}>
        <Routes>
          <Route path="/internallogin" element={<Login />}></Route>
          <Route path="/" element={<Login />}></Route>
          <Route path="/redirecting" element={<OktaLoginCallback />}></Route>
          <Route path="/:data/:value" element={<Login />}></Route>
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/quote/:id?" element={<Quote />} />
          <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
          <Route path="/quickregister" element={<QuickRegister />}></Route>
          <Route path="/registration" element={<Registration />}></Route>
          <Route path="/resetpassword" element={<ResetPassword />}></Route>
          <Route path="/orderstatus/:id?" element={<AuthGuard><OrderStatus /></AuthGuard>}>
            <Route
              path="policypickupdocs/:id?"
              element={<AuthGuard><ReadyforPickupDocuments /></AuthGuard>}
            ></Route>
          </Route>

          <Route path="/inquiries" element={<Inquiries />}></Route>
          <Route path="/quotesummary/:id?" element={<QuoteSummary />}></Route>
          <Route path="/securelogin/:data?" element={<SecureLogin />}></Route>
          <Route
            path="/dashboard"
            element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/changepassword"
            element={
              <AuthGuard>
                <ChangePassword />
              </AuthGuard>
            }
          />
             <Route
            path="clients/createpassword"
            element={
              // <AuthGuard>
                <ChangePassword />
              // </AuthGuard>
            }
          />
          <Route
            path="/accountsettings"
            element={
              <AuthGuard>
                <Profile />
              </AuthGuard>
            }
          />
          <Route
            path="/profilehistory"
            element={
              <AuthGuard>
                <ProfileHistory />
              </AuthGuard>
            }
          />
          <Route
            path="/notificationhistory"
            element={
              <AuthGuard>
                <NotificationHistory />
              </AuthGuard>
            }
          />
          <Route
            path="/billinghistory"
            element={
              <AuthGuard>
                <ManageBillingHistory />
              </AuthGuard>
            }
          />
          <Route
            path="/paymemtinformationhistory"
            element={
              <AuthGuard>
                <ManageBillingPaymentInformationHistory />
              </AuthGuard>
            }
          />
          <Route
            path="/order/:id?"
            element={
              <AuthGuard>
                <Orders />
              </AuthGuard>
            }
          />
          <Route
            path="/ordersummary/:id"
            element={
              <AuthGuard>
                <OrderSummaryMain />
              </AuthGuard>
            }
          />
          <Route
            path="/orderconfirmation/:id"
            element={
              <AuthGuard>
                <AdjudicatedOrder />
              </AuthGuard>
            }
          />
          <Route
            path="/viewOrder/:id"
            element={
              <AuthGuard>
                <ViewOrders />
              </AuthGuard>
            }
          />
          <Route
            path="/quote/history"
            element={
              <AuthGuard>
                <QuoteHistory />
              </AuthGuard>
            }
          />
          <Route
            path="/idverification/:id?"
            element={
              <AuthGuard>
                <IDverificationPage />
              </AuthGuard>
            }
          />
          <Route
            path="/downloadpolicies/:id"
            element={
              <AuthGuard>
                <DownloadPolicies />
              </AuthGuard>
            }
          />
          <Route
            path="/policypickup/:id"
            element={
              <AuthGuard>
                <PolicyPickup />
              </AuthGuard>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default Router;
